
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { renameProduct } from '../../actions/ProductDetailCreators';
import AttributesForm from "@components/AttributesForm";
import ProductShortTitle from "@components/ProductShortTitle";
import BrandInfo from '../../containers/BrandInfo';
import MerchantInfo from "../../containers/MerchantInfo";
import ProductComments from "@components/ProductComments";
import ProductSKUList from '@components/ProductSKUList';
import ProductDescriptions from '@components/ProductDescriptions';
import ProductRichTextSection from '@components/ProductRichTextEditor/ProductRichTextSection';
import utils from "../../common/utils";
import fetcher from "../../API";
import Select from 'react-select';
import Modal from '@components/Modal';
import { Table, message, Button, Space } from 'antd';
import ProductDetailHeader from './ProductDetailHeader';
import ProductDetailDesSection from './ProductDetailDesSection';
import { Decimal } from 'decimal.js' 
import _ from 'lodash'

const pinOptions = [{
    label: "AVAILABLE",
    value: "AVAILABLE"
},
{
    label: "UNAVAILABLE",
    value: "UNAVAILABLE"
}]

const columns = [
    {
        title: 'Key',
        dataIndex: 'key',
        key: 'key',
    },
    {
        title: 'Values',
        dataIndex: 'values',
        key: 'values',
        render: (values, record) => {
            if (values) {
                if (record.key == 'sibling_pids' || record.key == 'child_pids') {
                    return values.map(value => <><a href={`/discover/${value}`} >{value}</a><br /></>)
                } else {
                    return values.toString()
                }
            } else {
                return ''
            }
        }
    },
]

class ProductInfo extends Component<any, any> {

    state = {
        isBgmProduct: false,
        pinStatus: { label: "UNAVAILABLE", value: "UNAVAILABLE" },
        comment: '', // pin/unpin描述
        duration: '', // pin/unpin时间
        pinPriceSkuId: '_all',
        pinPriceCents: null,
        pinPriceDuration: null,
        weightInfo: null,
        merchantInfo: null,
    }

    componentDidMount() {
        const { product } = this.props || {}
        if (!product) return
        const merchantId = product.merchantId
        // 判断是否是bgm商家的商品
        if (merchantId) {
            fetcher.get(`api/v1/merchants/${merchantId}`).then(res => {
                this.setState({
                    isBgmProduct: res.data.kind && res.data.kind !== "PARTNER_SHOP",
                    merchantInfo: res.data,
                })
            }).catch(err => {
                console.error(err)
            })
        }
    }

    renameProduct(newName, callBack) {
        const { product } = this.props || {};
        this.props.renameProduct(product.id, newName, callBack);
    }

    getMinPriceSku = (skuId?: String) => {
        const availableSkus = this.props.product?.availableSkus
        if(!availableSkus) { return  }
        if (skuId && skuId !== '_all') {
          return availableSkus?.find(item => item.id === skuId)
        }
        return _.minBy<Record<string, any>>(availableSkus, item => item.cents)
    }

    getTargetSku = () => {
        const promotions = this.props.product?.promotions
        let skuId: undefined | String
        if(promotions) {
            skuId = promotions.skus?.find(item => item.priceTag === promotions.priceTag)?.id
        }
        return this.getMinPriceSku(skuId)
    }

    getProductPrice(): any {
        const { product } = this.props || {}
        if (!product) return {}
        const promotions = product.promotions
        let section: any
        if (promotions) {
             section = {
                originalPrice: promotions.originalPriceTag,
                price: promotions.priceTag,
                priceCN: promotions.priceTagCN,
                // 折扣
                off: promotions.off,
            }
            if (promotions.priceReductions && promotions.priceReductions.length) {
                // 额外折扣
                section.extraOff = promotions.priceReductions?.[0].title || ''
            }
        } else {
            section =  {
                originalPrice: product.originalPriceTag,
                price: product.priceTag,
                priceCN: product.priceTagCN,
                off: product.off,
            }
        }
        const targetSku = this.getTargetSku()
        const attributes = targetSku?.attributes?.attributes
        const beforeMarkupPriceStr = attributes?._intl_official_cents?.choices?.[0] 
        const commissionAppend = attributes?._intl_processing_fee_rate_append?.choices?.[0]
        const commissionDeduct = attributes?._intl_processing_fee_rate_deduct?.choices?.[0]
        const cents = targetSku?.cents
        const dollar = section.price?.slice(1) || 0
        if(beforeMarkupPriceStr && cents) {
            const beforeMarkupPrice = new Decimal(beforeMarkupPriceStr).div(new Decimal(100))
            section = Object.assign({}, section, {
              type: 'product',
              diff: new Decimal(cents)
                .div(100)
                .sub(beforeMarkupPrice)
                .toFixed(2),
              beforeMarkupPrice: `$${beforeMarkupPrice.toNumber()}`,
              mark_up_id: targetSku.attributes?.attributes?._intl_mark_up_id?.choices?.[0],
              unit: '$',
              dollar,
            })
        }else if (commissionAppend) {
            const ratio = new Decimal(commissionAppend).sub(commissionDeduct || 0).div(100)
            section = Object.assign({}, section, {
              commissionAppend,
              commissionDeduct,
              type: 'commission',
              diff: new Decimal(dollar)
                .mul(ratio)
                .toFixed(2),
              mark_up_id: targetSku.attributes?.attributes?._intl_mark_up_id?.choices?.[0],
              unit: '$',
              dollar,
            })
        }
         
        return section
    }

    pinOperation(product_id, params) {
        fetcher.post(`api/v1/products/${product_id}/pin`, params).then((response) => {
            if (params.on === false) {
                message.success('(UNPIN)成功，请点击重爬商品！');
            } else {
                message.success('(PIN)成功');
            }
        }).catch(error => {
            alert(error);
        });
    }

    pinPrice(product) {
        let { pinPriceSkuId, pinPriceCents, pinPriceDuration } = this.state
        let pinPriceList = [{
            skuId: pinPriceSkuId,
            cents: pinPriceCents,
            duration: pinPriceDuration
        }]
        if (pinPriceCents!==null) {
            if (pinPriceCents < 500) {
                let usPrice = pinPriceCents/100
                let toastString = '确认冻结该商品所有SKU 价格为' + pinPriceCents +'美分'+ '(' + (usPrice+'美元') + ')?'
                if (window.confirm(toastString)) {
                    fetcher.post(`api/v1/products/${product.id}/manual`, { pinPriceList }).then((response) => {
                        message.success('(PIN)成功');
                        window.location.reload();
                    }).catch(error => {
                        alert(error);
                    }); 
                }
            }  else {
                fetcher.post(`api/v1/products/${product.id}/manual`, { pinPriceList }).then((response) => {
                    message.success('(PIN)成功');
                    window.location.reload();
                }).catch(error => {
                    alert(error);
                }); 
            }
        }
    }
    pinProduct(product, isPin: boolean | null = null) {
        let { comment, duration, pinStatus } = this.state
        if (comment === '' || comment.trim() === '') {
            message.error('请填写comment')
            return
        }
        let param = {
            'duration': duration,
            'comment': comment
        }
        if (pinStatus.value) {
            param['status'] = pinStatus.value
        }
        if (isPin === false) {
            param['on'] = isPin
            this.pinOperation(product.id, param)
        } else {
            this.pinOperation(product.id, param)
        }
    }

    pinSku(product_id, status, sku_id, isPin, comment, duration) {
        if (comment === '' || comment.trim() === '') {
            message.error('请填写comment')
            return
        }
        if (isPin === false) {
            this.pinOperation(product_id, {
                'duration': duration,
                'skuIds': sku_id,
                'comment': comment,
                'on': isPin
            })
        } else {
            this.pinOperation(product_id, {
                'duration': duration,
                'comment': comment,
                'skuIds': sku_id
            })
        }
    }

    renderPinPriceDesModal() {
        const { pinPriceSkuId } = this.state
        return (
            <Modal
                id="pinPriceDesModal"
                header={{
                    title: "Complete Infomation"
                }}
                body={<div>
                    <div>
                        skuId:
                        <input type="text"
                            defaultValue={pinPriceSkuId}
                            className="form-control"
                            aria-label="skuId"
                            onChange={(e) => this.setState({ pinPriceSkuId: e.target.value })}></input>
                    </div>
                    <div>
                        <h5 style={{color:'#FF0000', fontWeight:'bold'}}>cents:</h5>
                        <input type="text"
                            className="form-control"
                            aria-label="cents"
                            onChange={(e) => this.setState({ pinPriceCents: e.target.value })}></input>
                    </div>
                    <div>
                        duration:(后缀应当以d,h,m,s中的一种为时间单位)
                        <input type="text"
                            className="form-control"
                            aria-label="duration"
                            onChange={(e) => this.setState({ pinPriceDuration: e.target.value })}></input>

                    </div>
                </div>}
                footer={
                    <div>
                        <button type="button" className="btn btn-secondary" data-dismiss="modal">
                            Close
                        </button>
                        <button
                            type="button"
                            className="btn btn-success ml-2"
                            // data-dismiss="modal"
                            onClick={() => this.pinPrice(this.props.product)}>
                            PIN
                        </button>
                    </div>
                }
            />
        )
    }

    renderPinDesModal() {
        const { product } = this.props || {};
        if (!product) return null
        let productPined: boolean;
        if (product.attributes) {
            productPined = product.attributes.attributes?.pinned?.choices?.[0] === '_all'
        } else {
            productPined = false
        }
        const { pinStatus } = this.state
        return (
            <Modal
                id="pinDesModal"
                header={{
                    title: "Complete Infomation"
                }}
                body={
                    <div>
                        <div>
                            comment:
                            <input type="text"
                                className="form-control"
                                aria-label="comment"
                                onChange={(e) => this.setState({ comment: e.target.value })}></input>
                        </div>
                        <div>
                            status:
                            <Select
                                value={pinStatus}
                                onChange={(e) => this.setState({ pinStatus: e })}
                                options={pinOptions}
                            />
                        </div>
                        <div>
                            duration:(后缀应当以d,h,m,s中的一种为时间单位)
                            <input type="text"
                                className="form-control"
                                aria-label="duration"
                                onChange={(e) => this.setState({ duration: e.target.value })}></input>

                        </div>
                    </div>
                }
                footer={
                    <div>
                        <button type="button" className="btn btn-secondary" data-dismiss="modal">
                            Close
                        </button>
                        <button
                            type="button"
                            className="btn btn-success ml-2"
                            data-dismiss="modal"
                            onClick={() => this.pinProduct(this.props.product, !productPined)}>
                            {productPined ? 'UNPIN' : 'PIN'}
                        </button>
                    </div>
                }
            />
        )
    }

    render() {
        const { product, refreshProductInfo, modifyNameHistoryList, hasRule } = this.props || {};
        if (!product) return null
        const { isBgmProduct, merchantInfo } = this.state
        const isSelfSale = product.merchantId === "4f991fd3-e0a5-5494-e315-fa29bc6584d3"; // FBB

        let skus = (product.availableSkus && product.availableSkus.length > 0) ? product.availableSkus.sort((a, b) => {
            let c = 0;
            if (a.color && a.color.name && b.color && b.color.name) {
                c = a.color.name.localeCompare(b.color.name);
            }

            if (c === 0 && a.size && a.size.name && b.size && b.size.name) {
                c = a.size.name.localeCompare(b.size.name);
            }
            return c;
        }) : []
        const productPriceSection = this.getProductPrice()
        return (
            <React.Fragment>
                <div className='col-md-9'>
                    {this.renderPinPriceDesModal()}
                    {this.renderPinDesModal()}
                    <ProductDetailHeader
                        product={product}
                        hasRule={hasRule}
                        productPriceSection={productPriceSection}
                        refreshProductInfo={refreshProductInfo}
                        renameProduct={renameProduct}
                        modifyNameHistoryList={modifyNameHistoryList}
                    />
                    <hr />
                    <ProductDetailDesSection product={product} refreshProductInfo={refreshProductInfo} />
                    <hr />
                </div>
                <Space direction="vertical" size="middle" style={{width: '100%'}}>
                    <div className='col-md-12'>
                        <div className="card">
                            <div className="card-header editable-bar"
                                data-toggle="collapse"
                                data-target="#collapseAttributes"
                                aria-expanded="false"
                                aria-controls="collapseAttributes">点我编辑商品短标题
                                {isBgmProduct && <span>（ BGM商家商品无法在此编辑，请在BGM系统编辑 ）</span>}</div>
                            <div className="collapse" id="collapseAttributes">
                                <div className="card-body">
                                    <ProductShortTitle product={product} isSelfSale={isSelfSale} />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* BGM商品展示此模块*/}
                    {isBgmProduct && (
                        <div className='col-md-12'>
                            <div className="card">
                                <div className="card-header editable-bar"
                                    data-toggle="collapse"
                                    data-target="#collapseBgmImageText"
                                    aria-expanded="false"
                                    aria-controls="collapseBgmImageText">BGM图文描述</div>
                                <div className="collapse show" id="collapseBgmImageText">
                                    <div className="card-body">
                                        <ProductRichTextSection
                                            productId={product.id}
                                            initialValue={product.imageText}
                                            legacyValue={product.editorial}
                                            readOnly={true}
                                        />
                                    </div>
                                </div>
                            </div>
                            <hr />
                        </div>
                    )}
                    <div className='col-md-12'>
                        <div className="card">
                            <div className="card-header editable-bar"
                                data-toggle="collapse"
                                data-target="#collapseDescription"
                                aria-expanded="false"
                                aria-controls="collapseDescription">点我展开商品描述</div>
                            <div className="collapse show" id="collapseDescription">
                                <div className="card-body">
                                    <div>
                                        <ProductDescriptions
                                            descriptions={product.description}
                                            productId={product.id}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-12'>
                        <div className="card">
                            <div className="card-header editable-bar"
                                data-toggle="collapse"
                                data-target="#collapseSKUList"
                                aria-expanded="false"
                                aria-controls="collapseSKUList">点我展开SKU列表</div>

                            <div className="collapse show" id="collapseSKUList">
                                <div className="card-body">
                                    <div>
                                        <ProductSKUList
                                            skus={skus}
                                            productInfo={product}
                                            merchantInfo={merchantInfo}
                                            productId={product.id}
                                            refreshProductInfo={refreshProductInfo}
                                            isSelfSale={isSelfSale}
                                            pinSku={(product_id, status, sku_id, isPin, comment, duration) => this.pinSku(product_id, status, sku_id, isPin, comment, duration)} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-12'>
                        <div className="card">
                            <div className="card-header editable-bar"
                                data-toggle="collapse"
                                data-target="#collapseAttr"
                                aria-expanded="false"
                                aria-controls="collapseAttr">点我查看Attributes</div>
                            <div className="collapse" id="collapseAttr">
                                <div className="card-body">
                                    <div>
                                        <Table columns={columns}
                                            dataSource={utils.setAttrTableData(product.attributes)}
                                            pagination={false}
                                            scroll={{ x: true }}
                                        />
                                        <Button style={{ marginTop: 8 }} size="small" onClick={() => { window.open(`/product-attribute/${product.id}`, '__blank') }}>
                                            编辑关联属性
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-12'>
                        <div className="card">
                            <div className="card-header editable-bar"
                                data-toggle="collapse"
                                data-target="#collapseAttributes"
                                aria-expanded="false"
                                aria-controls="collapseAttributes">点我编辑更多信息
                                {isBgmProduct && <span>（ BGM商家商品无法在此编辑，请在BGM系统编辑 ）</span>}</div>
                            <div className="collapse" id="collapseAttributes">
                                <div className="card-body">
                                    <AttributesForm product={product} isSelfSale={isSelfSale} />
                                </div>
                            </div>
                        </div>
                    </div>
                </Space>
                <hr className="card col-md-12" />
                {product.merchantId ? <div className="col-md-12"><MerchantInfo merchantId={product.merchantId} officialUrl={product.officialURL} /></div> : <div className='text-secondary'>找不到商家信息...</div>}
                <hr />
                {product.brandId ? <div className="col-md-12"><BrandInfo brandId={product.brandId} /></div> : <div className='text-secondary'>正在加载品牌信息...</div>}
                <hr />
                <div className="col-md-12"><ProductComments productId={product.id} /></div>
                <hr />
            </React.Fragment >
        );
    }
}

export default connect(null, { renameProduct })(ProductInfo);
